import { ArrowRightIcon } from "lucide-react";

import { LoadingIndicator } from "@/components";
import { Button } from "@/components/ui/button";

export const SaveAndNextButton = ({
  disabled,
  isPending,
}: {
  disabled?: boolean;
  isPending?: boolean;
}) => {
  return (
    <Button
      type="submit"
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={disabled || isPending}
    >
      {isPending ? (
        <LoadingIndicator gearColor="white" variant="small" />
      ) : (
        <>
          Save &amp; next
          <ArrowRightIcon className="h-4 w-4" />
        </>
      )}
    </Button>
  );
};
